import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { generateLinkDatas } from './utils';

/**
 * Link
 * @param children {node}
 * @param data {array}
 * @param pop {bool}
 * @returns {JSX.Element}
 */
const Link = ({
  children,
  data = [],
  pop = false,
  customLink,
  customLinkParam,
  newTab
}) => {
  const content = generateLinkDatas(data, newTab, customLink, customLinkParam);
  return (
    <>
      {pop && (
        // FIN-14012 (S1) — bottom-anchored: the default `top` placement opened the card over the
        // table header (measured on the FRAML customer Alert History tab: fully inside the
        // two-row header). The card and its selectable text are otherwise unchanged.
        <Popover
          placement="bottomLeft"
          content={
            <>
              {content}
              {children}
            </>
          }>
          {content}
          {children}
        </Popover>
      )}
      {!pop && (
        <>
          {content}
          {children}
        </>
      )}
    </>
  );
};

Link.propTypes = {
  children: PropTypes.node,
  data: PropTypes.array,
  pop: PropTypes.bool
};

export default Link;
